import React, { useState } from "react"
import tw, { styled } from "twin.macro"

import Modal from "components/modal"
import PlayButton from "images/icons/play-button.svg"

const Styles = styled.div`
  .play-button {
    max-width: auto;
    padding: 0 !important;
    position: absolute;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
    z-index: 2;
    height: 80px;
    width: 80px;
  }

  .caption {
    ${tw`absolute w-full text-center text-white font-extrabold text-3xl m:text-4xl l:text-5xl
         leading-normal m:leading-normal l:leading-normal`}

    padding: 0 !important;
    top: calc(25% - 40px);
    z-index: 2;
  }

  .video-preview {
    ${tw`absolute top-0 left-0 w-full h-full object-cover`}
  }

  .gradient {
    ${tw`absolute top-0 left-0 w-full h-full hidden`}

    z-index: 1;
  }
`

const YouTube = ({
  videoId = null,
  active = false,
  autoplay = false,
  fixAspectRatio = true,
  videoUrl = null,
  preview = null,
  videoPreview = null,
  caption = null,
}) => {
  const [player, setPlayer] = useState(false)

  function openPlayer(e) {
    e.preventDefault()
    setPlayer(true)
  }

  function closePlayer(e) {
    setPlayer(false)
  }

  if (videoId === null && videoUrl !== null) {
    var re = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi
    videoId = videoUrl.replace(re, "$1")
  }

  if (! preview) {
    preview = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
  }

  return (
    <Styles
      className="youtube-video"
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        paddingBottom: fixAspectRatio ? "56.25%" : 0 /* 16:9 */,
      }}
    >
      {!!active && (
        <iframe
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          src={`https://www.youtube.com/embed/${videoId}?rel=0${
            autoplay ? "&autoplay=1" : ""
          }`}
          title="YouTube player"
          frameBorder="0"
          allow="autoplay; fullscreen"
        />
      )}
      {!active && (
        <>
          <a
            href={`https://www.youtube.com/watch?v=${videoId}`}
            rel="noopener noreferrer"
            target="_blank"
            onClick={openPlayer}
          >
            <div className="gradient" />
            <img
              src={preview}
              title="YouTube player"
              loading="lazy"
              alt=""
              className="video-preview"
            />
            {videoPreview && (
              <video
                playsInline={true}
                autoPlay={true}
                muted={true}
                loop={true}
                className="video-preview"
              >
                <source src={videoPreview} type="video/mp4" />
              </video>
            )}
            <div className="caption">
              {caption}
            </div>
            <img
              className="play-button"
              src={PlayButton}
              alt="play video"
              height={80}
              width={80}
            />
          </a>
          <Modal isVisible={player} onClose={closePlayer}>
            <div className="video-player h-full w-full m:px-16">
              <YouTube
                videoId={videoId}
                active={true}
                autoplay={true}
                fixAspectRatio={false}
              />
            </div>
          </Modal>
        </>
      )}
    </Styles>
  )
}

export default YouTube
